import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import FilterElementViewModelType from '@/ViewModels/Controls/FilterElementViewModel';
import LinkType from '@/Controls/Link';
import DropDownListType from '@/Controls/DropDownList';
import Utilities from '@/Utility/Utilities';

export default class FilterElement extends Control {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private DropDownList = ComponentManager.getControl<typeof DropDownListType>('DropDownList');
    private jQueryControl: JQuery;
    private dropDownListColumns: DropDownListType;
    private dropDownListOperators: DropDownListType;
    private dropDownListConnectors: DropDownListType;
    private linkAddFilterElement: LinkType;
    private linkRemoveFilterElement: LinkType;

    public constructor(private viewModel: FilterElementViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        $('<div class="columns">').appendTo(this.jQueryControl);
        $('<div class="operators">').appendTo(this.jQueryControl);
        $('<div class="control">').appendTo(this.jQueryControl);
        $('<div class="connectors">').appendTo(this.jQueryControl);

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'filterelement',
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier,
            tooltip: this.viewModel.tooltip,
            invalid: this.viewModel.invalidationText,

            locator: this.viewModel.locator,

            filterElement: {
                columns: this.viewModel.dropDownListColumns,
                operators: this.viewModel.dropDownListOperators,
                genericObject: this.viewModel.genericObject,
                context: this.viewModel,
                includeAllPrincipals: this.viewModel.filter.includeAllPrincipals,
                includeBasePrincipals: this.viewModel.filter.includeBasePrincipals,
                includeSubPrincipals: this.viewModel.filter.includeSubPrincipals
            },

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),
            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.dropDownListColumns != null) {
            this.dropDownListColumns = new this.DropDownList(this.viewModel.dropDownListColumns);
            let tuple = this.dropDownListColumns.getTuple();

            tuple.control.appendTo(this.jQueryControl.find('.columns'));
        }

        if (this.viewModel.dropDownListOperators != null) {
            this.dropDownListOperators = new this.DropDownList(this.viewModel.dropDownListOperators);
            let tuple = this.dropDownListOperators.getTuple();

            tuple.control.appendTo(this.jQueryControl.find('.operators'));
        }

        if (this.viewModel.dropDownListConnectors != null) {
            this.dropDownListConnectors = new this.DropDownList(this.viewModel.dropDownListConnectors);
            let tuple = this.dropDownListConnectors.getTuple();

            tuple.control.appendTo(this.jQueryControl.find('.connectors'));
        }
    }
}

ComponentManager.setControl('FilterElement', FilterElement, 'RADPresentation.HTMLClient.DefaultViewExtensions');